import './common.js';

import './libs/tab/tab.js';
import './libs/media/media.js';
import './libs/block-main-catalog.js';
import './libs/appraisal-slider.js';

// import '../scss/main.scss';

/* пролистываение по гет параметру до блока */
var url_string = window.location.href;
var url = new URL(url_string);
var blockID = url.searchParams.get("block");
if(blockID && document.getElementById(blockID)) {
    document.getElementById(blockID).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
/* пролистываение по гет параметру до блока */

// Вместо вложенных ссылок, используется windows.location и клик эвент. Вложенные ссылки плохо поддерживаются
/* Пока карточки-ссылки не нужны
document.querySelectorAll(".category-card").forEach(el => {
    el.addEventListener("click", function(e) {
        window.location.href = e.target.getAttribute('href');
    });
});
*/
